import React from 'react'

export default function Footer() {
  return (
   <>
   <section class="tv-series">
        <div class="container">

          <p class="section-subtitle">Best TV Series</p>

          <h2 class="h2 section-title">World Best TV Series</h2>

          <ul class="movies-list">

            <li>
              <div class="movie-card">

                <a href="./movie-details.html">
                  <figure class="card-banner">
                    <img src="../images/series-1.png" alt="Moon Knight movie poster"/>
                  </figure>
                </a>

                <div class="title-wrapper">
                  <a href="./movie-details.html">
                    <h3 class="card-title">Moon Knight</h3>
                  </a>

                  <time datetime="2022">2022</time>
                </div>

                <div class="card-meta">
                  <div class="badge badge-outline">2K</div>

                  <div class="duration">
                  <i  style={{color:'yellow'}} class="fas fa-clock"></i>

                    <time datetime="PT47M">47 min</time>
                  </div>

                  <div class="rating">
                  <i  style={{color:'yellow'}} class="fas fa-star"></i>
                    <data>8.6</data>
                  </div>
                </div>

              </div>
            </li>

            <li>
              <div class="movie-card">

                <a href="./movie-details.html">
                  <figure class="card-banner">
                    <img src="../images/series-2.png" alt="Halo movie poster"/>
                  </figure>
                </a>

                <div class="title-wrapper">
                  <a href="./movie-details.html">
                    <h3 class="card-title">Halo</h3>
                  </a>

                  <time datetime="2022">2022</time>
                </div>

                <div class="card-meta">
                  <div class="badge badge-outline">2K</div>

                  <div class="duration">
                  <i  style={{color:'yellow'}} class="fas fa-clock"></i>

                    <time datetime="PT59M">59 min</time>
                  </div>

                  <div class="rating">
                  <i  style={{color:'yellow'}} class="fas fa-star"></i>
                    <data>8.8</data>
                  </div>
                </div>

              </div>
            </li>

            <li>
              <div class="movie-card">

                <a href="./movie-details.html">
                  <figure class="card-banner">
                    <img src="../images/series-3.png" alt="Vikings: Valhalla movie poster"/>
                  </figure>
                </a>

                <div class="title-wrapper">
                  <a href="./movie-details.html">
                    <h3 class="card-title">Vikings: Valhalla</h3>
                  </a>

                  <time datetime="2022">2022</time>
                </div>

                <div class="card-meta">
                  <div class="badge badge-outline">2K</div>

                  <div class="duration">
                  <i  style={{color:'yellow'}} class="fas fa-clock"></i>
                    <time datetime="PT51M">51 min</time>
                  </div>

                  <div class="rating">
                  <i  style={{color:'yellow'}} class="fas fa-star"></i>
                    <data>8.3</data>
                  </div>
                </div>

              </div>
            </li>

            <li>
              <div class="movie-card">

                <a href="./movie-details.html">
                  <figure class="card-banner">
                    <img src="../images/series-4.png" alt="Money Heist movie poster"/>
                  </figure>
                </a>

                <div class="title-wrapper">
                  <a href="./movie-details.html">
                    <h3 class="card-title">Money Heist</h3>
                  </a>

                  <time datetime="2017">2017</time>
                </div>

                <div class="card-meta">
                  <div class="badge badge-outline">4K</div>

                  <div class="duration">
                  <i  style={{color:'yellow'}} class="fas fa-clock"></i>

                    <time datetime="PT70M">70 min</time>
                  </div>

                  <div class="rating">
                  <i  style={{color:'yellow'}} class="fas fa-star"></i>

                    <data>8.3</data>
                  </div>
                </div>

              </div>
            </li>

          </ul>

        </div>
      </section>
   </>
  )
}
